import React from 'react'
import { useListing } from '@/providers';

export const LodgingDetails = () => {
    const { listingDetails } = useListing();

    const {
        id: listing_id,
        lodging_type,
        no_of_guest,
        no_of_bedrooms,
        no_of_beds,
        no_of_bathrooms,
        no_of_rooms,
        size,
        unit_of_measure,
        check_in_after,
        check_out_before,
    } = listingDetails;

    return (
        <div className="block-body !px-0 flex flex-col">
            <div className="block-left">
                <h3 className="pb-8 text-lg font-bold text-start">Details</h3>
            </div>
            <div >
                <ul className="grid grid-cols-2 gap-4 !pl-0">
                    <li className="flex items-center space-x-2">
                        <i className="text-gray-500 fas fa-id-badge"></i>
                        <span>
                            ID#: <strong>{listing_id}</strong>
                        </span>
                    </li>
                    <li className="flex items-center space-x-2">
                        <i className="text-gray-500 fas fa-users"></i>
                        <span>
                            Guests: <strong>{no_of_guest}</strong>
                        </span>
                    </li>
                    <li className="flex items-center space-x-2">
                        <i className="text-gray-500 fas fa-bed"></i>
                        <span>
                            Bedrooms: <strong>{no_of_bedrooms}</strong>
                        </span>
                    </li>
                    <li className="flex items-center space-x-2">
                        <i className="text-gray-500 fas fa-bed"></i>
                        <span>
                            Beds: <strong>{no_of_beds}</strong>
                        </span>
                    </li>
                    <li className="flex items-center space-x-2">
                        <i className="text-gray-500 fas fa-bath"></i>
                        <span>
                            Bathrooms: <strong>{no_of_bathrooms}</strong>
                        </span>
                    </li>
                    <li className="flex items-center space-x-2">
                        <i className="text-gray-500 fas fa-home"></i>
                        <span>
                            Rooms: <strong>{no_of_rooms}</strong>
                        </span>
                    </li>
                    <li className="flex items-center space-x-2">
                        <i className="text-gray-500 fas fa-calendar-day"></i>
                        <span>
                            Check-in After: <strong>{check_in_after}</strong>
                        </span>
                    </li>
                    <li className="flex items-center space-x-2">
                        <i className="text-gray-500 fas fa-calendar-day"></i>
                        <span>
                            Check-out Before: <strong>{check_out_before}</strong>
                        </span>
                    </li>
                    <li className="flex items-center space-x-2">
                        <i className="text-gray-500 fas fa-key"></i>
                        <span>
                            Dwelling Type: <strong>{lodging_type}</strong>
                        </span>
                    </li>
                    <li className="flex items-center space-x-2">
                        <i className="text-gray-500 fas fa-ruler"></i>
                        <span>
                            Size: <strong>{size} {unit_of_measure}</strong>
                        </span>
                    </li>
                </ul>
            </div>
        </div>
    )
}
